import dayjs from 'dayjs';
import React from 'react';
import { DataTable } from '../../../components';
import { DataTableProps } from '../../../components/DataTable/DataTable';
import { formatDollars, formatDateMMDDYY } from '../../../helpers/utilityFunctions';
import { SubscriptionCharge } from '../../../models/RevShareData';
import { pricebookHeaders } from './PricebookTable';

export const formatCharges = (charges: SubscriptionCharge[] = []) => {
  return charges?.map(charge => ({
    id: charge.chargeId,
    chargeId: charge.chargeId,
    datePaid: formatDateMMDDYY(charge.datePaid),
    quantity: charge.refunded ? -charge.quantity : charge.quantity,
    amountPaid: formatDollars(charge.refunded ? -charge.amountPaid : charge.amountPaid),
  }));
};

export const ChargesTable: React.FC<DataTableProps> = ({
  data: charges,
  headers = pricebookHeaders,
  ...rest
}) => (
  <DataTable
    headers={headers}
    data={formatCharges(charges as SubscriptionCharge[])}
    customSort={[
      {
        column: 'datePaid',
        function: (a, b) => dayjs(a.datePaid).valueOf() - dayjs(b.datePaid).valueOf(),
      },
    ]}
    {...rest}
  />
);
